import { useGetTaskStates } from "@hooks";
import { Device, Document, RoadmapTasks, User } from "@models";
import { TemplateConfig } from "@types";
import { meetsVisibilityConditions } from "@utils";
import { useParams } from "react-router-dom";
import OnboardingTooltip from "src/components/OnboardingTooltip/OnboardingTooltip";
import Card from "src/components/Roadmap/Cards/Card";
import { RoadmapCard } from "../../../config";
import { areAllCardTasksCompleted } from "../utils";

type Props = {
  roadmap: {
    title: string;
    id: string;
    disabled?: boolean;
    cards: RoadmapCard[];
  }[];
  documents: Document[];
  user: User;
  device: Device;
  onClickOpenCardDialog: (cardId: string, stageId: string) => void;
  templatesConfig: TemplateConfig;
  tasks: RoadmapTasks;
};

export const Cards = (props: Props) => {
  const { orgId = "", deviceId = "" } = useParams();
  const { data: taskStates } = useGetTaskStates({
    orgId,
    deviceId,
    enabled: !!orgId && !!deviceId,
  });

  const { roadmap, onClickOpenCardDialog, tasks, documents, device } = props;

  let foundNextTodoCard = false;

  return (
    <div className="flex">
      {roadmap.map((step) => {
        return (
          <div className="mt-3 flex w-1/5 flex-col gap-y-2" key={step.title}>
            {step.cards.map((card) => {
              if (!tasks) {
                return null;
              }

              const cardTasks = tasks.filter(
                (task) =>
                  task.parentCardKey === card.cardKey &&
                  meetsVisibilityConditions(
                    task.visibilityConditions,
                    device,
                    documents
                  )
              );

              const cardDocuments = props.documents.filter(
                (document) =>
                  document.templateKey !== null &&
                  cardTasks.map((t) => t.taskKey).includes(document.templateKey)
              );

              const allCardTasksCompleted = areAllCardTasksCompleted(
                cardTasks,
                cardDocuments,
                props.user,
                props.documents,
                orgId,
                taskStates
              );

              const CardToRender = () => (
                <Card
                  title={card.title}
                  cardId={card.cardKey}
                  disabled={step.disabled || card.enabled === false}
                  openCardDialog={() =>
                    onClickOpenCardDialog(card.cardKey, step.id)
                  }
                  allCardTasksCompleted={allCardTasksCompleted}
                />
              );

              if (!foundNextTodoCard && !allCardTasksCompleted) {
                foundNextTodoCard = true;
                return (
                  <OnboardingTooltip
                    databaseId="nextTodoCardTooltipSeen"
                    placement="right-start"
                    title="Your next task awaits..."
                    subtitle="Grey cards have tasks you must complete."
                    buttonText="Got it!"
                    key={`${card.title}-tooltip`}
                  >
                    <CardToRender key={card.title} />
                  </OnboardingTooltip>
                );
              }

              return <CardToRender key={card.title} />;
            })}
          </div>
        );
      })}
    </div>
  );
};
